<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" style="padding: 120px 0px 90px 0px;">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="background-image: url(static/upload/hp2-testimonial-bg-1.png); background-size: cover; background-position: top center;"
             data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-40 gdlr-core-column-first">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 25px;">
                            <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                                  style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                              <span class="gdlr-core-title-item-left-dot"
                                    style="width: 5px; height: 5px; background-color: #d32525; margin-right: 13px;"></span>Management Team in Shanghai</span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                        管理团队
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span></h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                       style="padding-bottom: 10px;">
                    <div class="gdlr-core-text-box-item-content"
                         style="font-size: 21px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #353535;">
                      <p>
                        匯德管理团队核心成员，均毕业于海内外名校，拥有法学、税务、金融专业背景，曾有执业律师、税务师、大型金融机构工作经验。团队一直以来从事资本市场、离岸法域、跨境架构搭建、信托管理，股权激励，投融资等业务，服务经验超过10年，服务新经济企业、专业投资机构超四千家。主导多个项目的投资及上市发行，为上市企业提供多方位专业服务。</p>
                      <br/>
                      <p>
                        上海总部共有30余位成员，以法学、税务专业教育背景为主，熟悉企业跨境架构设计、高净值人士财富传承规划、赛道投行分析、资产配置等业务。另设有香港团队及海南分公司，全方位的为企业客户及个人客户提供专业化服务。</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-65853">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 100px 0px 0px 0px;">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-right-align"
                       style="padding-bottom: 0px;">
                    <a
                      class="gdlr-core-button gdlr-core-button-gradient gdlr-core-right-align gdlr-core-button-no-border"
                      href="mailto:info@huidetrust.com" style="
                            font-size: 20px;
                            font-weight: 500;
                            letter-spacing: 0px;
                            color: #ffffff;
                            text-transform: none;
                            border-radius: 0px;
                            -moz-border-radius: 0px;
                            -webkit-border-radius: 0px;
                            background: #d32525;
                            ">
                      <span class="gdlr-core-content">联系团队</span>
                      <i class="gdlr-core-pos-right fa fa-long-arrow-right"
                         style="font-size: 22px; color: #ffffff;"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-personnel-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-personnel-item-style-grid-with-background gdlr-core-personnel-style-grid gdlr-core-with-background gdlr-core-item-pdlr"
                    style="padding-bottom: 0px;">
                    <div class="gdlr-core-flexslider flexslider gdlr-core-js-2 gdlr-core-bullet-style-cylinder"
                         data-type="carousel" data-column="3" data-move="1" data-nav="bullet"
                         data-nav-parent="gdlr-core-personnel-item" data-controls-top-margin="60px">
                      <ul class="slides" v-if="0">
                        <!-- 团队 -->
                        <li class="gdlr-core-item-mglr">
                          <div class="gdlr-core-personnel-list clearfix gdlr-core-outer-frame-element"
                               style="box-shadow: 0 20px 30px rgba(0, 0, 0, 0.06); -moz-box-shadow: 0 20px 30px rgba(0, 0, 0, 0.06); -webkit-box-shadow: 0 20px 30px rgba(0, 0, 0, 0.06);">
                            <div class="gdlr-core-personnel-list-image gdlr-core-media-image">
                              <a href="/#/">
                                <img src="static/upload/P1.jpg" alt="" width="1000" height="1000" title="P1"/></a>
                              <div class="gdlr-core-hover-opacity">
                                <div class="gdlr-core-personnel-thumbnail-hover-content gdlr-core-center">
                                  <div class="gdlr-core-personnel-thumbnail-hover-title">
                                    <a href="/#/">NAME</a></div>
                                  <div class="gdlr-core-personnel-thumbnail-hover-social gdlr-core-round-border">
                                    <div
                                      class="gdlr-core-social-network-item gdlr-core-item-pdb gdlr-core-none-align"
                                      style="padding-bottom: 0px;">
                                      <a href="#" target="_blank" class="gdlr-core-social-network-icon"
                                         title="facebook">
                                        <i class="fa fa-facebook"></i>
                                      </a>
                                      <a href="#" target="_blank" class="gdlr-core-social-network-icon"
                                         title="linkedin">
                                        <i class="fa fa-linkedin"></i>
                                      </a>
                                      <a href="#" target="_blank" class="gdlr-core-social-network-icon"
                                         title="twitter">
                                        <i class="fa fa-twitter"></i>
                                      </a>
                                    </div>
                                  </div>
                                  <div class="gdlr-core-personnel-thumbnail-hover-excerpt"></div>
                                </div>
                              </div>
                            </div>
                            <div class="gdlr-core-personnel-list-content-wrap">
                              <h3 class="gdlr-core-personnel-list-title"
                                  style="font-size: 26px; font-weight: 500; letter-spacing: 0px; text-transform: none;">
                                <a href="/#/">NAME</a></h3>
                              <div
                                class="gdlr-core-personnel-list-position gdlr-core-info-font gdlr-core-skin-caption"
                                style="font-size: 17px; font-weight: 500; font-style: normal; letter-spacing: 0px;">
                                Founder & CEO
                              </div>
                              <div class="gdlr-core-personnel-list-social">
                                <div class="gdlr-core-social-network-item gdlr-core-item-pdb gdlr-core-none-align"
                                     style="padding-bottom: 0px;">
                                  <a href="#" target="_blank" class="gdlr-core-social-network-icon"
                                     title="facebook">
                                    <i class="fa fa-facebook"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gdlr-core-pbf-wrapper" style="padding: 120px 0px 90px 0px;">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="background-image: url(static/upload/hp2-testimonial-bg-1.png); background-size: cover; background-position: top center;"
             data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-40 gdlr-core-column-first">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 25px;">
                            <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                                  style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                              <span class="gdlr-core-title-item-left-dot"
                                    style="width: 5px; height: 5px; background-color: #d32525; margin-right: 13px;"></span>Management Team in Hong Kong</span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                        香港顾问团队
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span></h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                       style="padding-bottom: 10px;">
                    <div class="gdlr-core-text-box-item-content"
                         style="font-size: 21px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #353535;">
                      <p>
                        香港顾问团队拥有人均超过15年以上的金融业工作经验，熟悉金融产业上中下游资源和管理，分别涵盖了在投资管理领域、产品设计创新、为财富管理机构提供资产配置产品、服务、合规管理等方面，具有丰富的经验及能力。</p>
                      <br/>
                      <p>香港顾问团队共有20位成员，核心投资团队共6位，曾就职于大型国内外金融机构的高管职位，且有着优秀的教育及专业背景。部分团队成员一起共事时间长达10年。</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Team'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Team.vue